import { Button } from 'components/ui/button';
import { IconMessage } from 'components/ui/icon-message';
import { Frown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const MainErrorFallback = () => {
    const navigate = useNavigate();
    return (
        <div
            className="flex h-full w-full flex-col items-center justify-center text-destructive"
            role="alert"
        >
            <IconMessage
                icon={Frown}
                title="Ooops, something went wrong"
                subtitle="Please try refreshing the page or contacting support if the issue persists."
                buttons={[
                    <Button
                        key="refresh"
                        className="mt-4"
                        onClick={() => navigate(0)}
                    >
                        Refresh
                    </Button>,
                ]}
            />
        </div>
    );
};
